import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { switchMap, take } from 'rxjs';

import { getSelectedCustomerIdent } from '@resident-nx/shared';
import { KeycloakService } from '../services/authentication/keycloak.service';

export function authWebInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const keycloakService = inject(KeycloakService);
  const store = inject(Store);

  if (req.url.indexOf('/graphql') === -1) {
    return next(req);
  }

  return store.select(getSelectedCustomerIdent).pipe(
    take(1),
    switchMap(customerIdent => {
      if (keycloakService.token) {
        req = req.clone({
          setHeaders: { Authorization: `Bearer ${keycloakService.token}` },
        });
      }
      if (customerIdent) {
        req = req.clone({
          setHeaders: { 'X-Customer-Ident': customerIdent },
        });
      }
      return next(req);
    })
  );
}
